export const MULTI_AGENT_ROLES = [
    {
        id: "orchestrator-agent",
        name: "Orchestrator Agent",
        role: "orchestrator",
        version: "1.0.0",
        description: "Coordinates multi-agent workflows and plans task DAGs; executes read-only tools without approval and requires approval for mutating actions.",
        capabilities: ["plan", "delegate", "monitor"],
        executionMode: "read_only",
        approvalRequired: false,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: false,
        fileMutationAllowed: false,
        commandExecutionAllowed: false,
        maxCost: 1000,
        maxDurationMs: 60000,
    },
    {
        id: "researcher-agent",
        name: "Researcher Agent",
        role: "researcher",
        version: "1.0.0",
        description: "Performs read-only research and citation tasks.",
        capabilities: ["search", "summarize", "cite"],
        executionMode: "read_only",
        approvalRequired: false,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: false,
        fileMutationAllowed: false,
        commandExecutionAllowed: false,
        maxCost: 1000,
        maxDurationMs: 60000,
    },
    {
        id: "writer-agent",
        name: "Writer Agent",
        role: "writer",
        version: "1.0.0",
        description: "Generates written content proposals without file mutation.",
        capabilities: ["draft", "edit", "format"],
        executionMode: "plan_only",
        approvalRequired: false,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: false,
        fileMutationAllowed: false,
        commandExecutionAllowed: false,
        maxCost: 1000,
        maxDurationMs: 60000,
    },
    {
        id: "coder-agent",
        name: "Coder Agent",
        role: "coder",
        version: "1.0.0",
        description: "Generates and applies code changes inside an isolated workspace after approval.",
        capabilities: ["generate-code", "refactor", "document", "apply-patch"],
        executionMode: "approval_required",
        approvalRequired: true,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: false,
        fileMutationAllowed: true,
        commandExecutionAllowed: false,
        maxCost: 2000,
        maxDurationMs: 120000,
    },
    {
        id: "code-reviewer",
        name: "Code Reviewer Agent",
        role: "reviewer",
        version: "1.0.0",
        description: "Reviews code for quality and security; cannot approve its own patch.",
        capabilities: ["review", "lint", "security-check"],
        executionMode: "read_only",
        approvalRequired: false,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: false,
        fileMutationAllowed: false,
        commandExecutionAllowed: false,
        maxCost: 1000,
        maxDurationMs: 60000,
    },
    {
        id: "planner-agent",
        name: "Planner Agent",
        role: "planner",
        version: "1.0.0",
        description: "Creates execution plans and estimates for multi-agent runs.",
        capabilities: ["plan", "estimate", "schedule"],
        executionMode: "plan_only",
        approvalRequired: false,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: false,
        fileMutationAllowed: false,
        commandExecutionAllowed: false,
        maxCost: 1000,
        maxDurationMs: 60000,
    },
    {
        id: "tester-agent",
        name: "Tester Agent",
        role: "tester",
        version: "1.0.0",
        description: "Executes test plans and reports results without mutating source.",
        capabilities: ["test-plan", "mock", "validate"],
        executionMode: "approval_required",
        approvalRequired: true,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: false,
        fileMutationAllowed: false,
        commandExecutionAllowed: false,
        maxCost: 1000,
        maxDurationMs: 120000,
    },
    {
        id: "designer-agent",
        name: "Designer Agent",
        role: "designer",
        version: "1.0.0",
        description: "Creates design previews and wireframes in plan-only mode.",
        capabilities: ["wireframe", "prototype", "style"],
        executionMode: "plan_only",
        approvalRequired: false,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: false,
        fileMutationAllowed: false,
        commandExecutionAllowed: false,
        maxCost: 1000,
        maxDurationMs: 60000,
    },
    {
        id: "analyst-agent",
        name: "Analyst Agent",
        role: "analyst",
        version: "1.0.0",
        description: "Analyzes data and produces read-only reports.",
        capabilities: ["analyze", "visualize", "report"],
        executionMode: "read_only",
        approvalRequired: false,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: false,
        fileMutationAllowed: false,
        commandExecutionAllowed: false,
        maxCost: 1000,
        maxDurationMs: 60000,
    },
    {
        id: "teacher-agent",
        name: "Teacher Agent",
        role: "teacher",
        version: "1.0.0",
        description: "Provides educational content and explanations.",
        capabilities: ["explain", "quiz", "feedback"],
        executionMode: "plan_only",
        approvalRequired: false,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: false,
        fileMutationAllowed: false,
        commandExecutionAllowed: false,
        maxCost: 1000,
        maxDurationMs: 60000,
    },
    {
        id: "assistant-agent",
        name: "Assistant Agent",
        role: "assistant",
        version: "1.0.0",
        description: "General-purpose assistant operating in plan/read mode.",
        capabilities: ["assist", "answer", "guide"],
        executionMode: "read_only",
        approvalRequired: false,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: false,
        fileMutationAllowed: false,
        commandExecutionAllowed: false,
        maxCost: 1000,
        maxDurationMs: 60000,
    },
    {
        id: "system-architect",
        name: "System Architect",
        role: "system-architect",
        version: "1.0.0",
        description: "Designs system structure and module boundaries in plan mode.",
        capabilities: ["design-system", "module-boundary", "review-architecture"],
        executionMode: "plan_only",
        approvalRequired: false,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: false,
        fileMutationAllowed: false,
        commandExecutionAllowed: false,
        maxCost: 1000,
        maxDurationMs: 60000,
    },
    {
        id: "security-policy",
        name: "Security Policy Agent",
        role: "security-policy",
        version: "1.0.0",
        description: "Audits code and runtime policy for security violations.",
        capabilities: ["security-check", "policy-audit", "threat-model"],
        executionMode: "approval_required",
        approvalRequired: true,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: false,
        fileMutationAllowed: false,
        commandExecutionAllowed: false,
        maxCost: 1000,
        maxDurationMs: 60000,
    },
    {
        id: "mcp-integration",
        name: "MCP Integration Agent",
        role: "mcp-integration",
        version: "1.0.0",
        description: "Configures MCP tool routers and validates tool schemas.",
        capabilities: ["mcp-config", "schema-validate", "tool-audit"],
        executionMode: "approval_required",
        approvalRequired: true,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: false,
        fileMutationAllowed: false,
        commandExecutionAllowed: false,
        maxCost: 1000,
        maxDurationMs: 60000,
    },
    {
        id: "database-migration",
        name: "Database Migration Agent",
        role: "database-migration",
        version: "1.0.0",
        description: "Reviews and applies schema migrations after explicit approval.",
        capabilities: ["schema-review", "migration-plan", "apply-migration"],
        executionMode: "approval_required",
        approvalRequired: true,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: true,
        fileMutationAllowed: false,
        commandExecutionAllowed: false,
        maxCost: 2000,
        maxDurationMs: 120000,
    },
    {
        id: "release-devops",
        name: "Release DevOps Agent",
        role: "release-devops",
        version: "1.0.0",
        description: "Prepares release artifacts and deployment plans with owner approval.",
        capabilities: ["release-plan", "build-config", "deploy-preview"],
        executionMode: "approval_required",
        approvalRequired: true,
        auditEnabled: true,
        networkAllowed: false,
        productionDbAllowed: false,
        fileMutationAllowed: false,
        commandExecutionAllowed: false,
        maxCost: 2000,
        maxDurationMs: 120000,
    },
];
export function getMultiAgentRoleById(id) {
    return MULTI_AGENT_ROLES.find((r) => r.id === id);
}
export function listMultiAgentRoleIds() {
    return MULTI_AGENT_ROLES.map((r) => r.id);
}
export function validateMultiAgentRoleRegistry() {
    const errors = [];
    const ids = new Set();
    for (const role of MULTI_AGENT_ROLES) {
        if (ids.has(role.id))
            errors.push(`Duplicate role id: ${role.id}`);
        ids.add(role.id);
        if (!role.id)
            errors.push("Role missing id");
        if (!role.name)
            errors.push(`Role ${role.id} missing name`);
        if (!role.role)
            errors.push(`Role ${role.id} missing role`);
        if (!role.version)
            errors.push(`Role ${role.id} missing version`);
        if (!role.description)
            errors.push(`Role ${role.id} missing description`);
        if (!Array.isArray(role.capabilities) || role.capabilities.length === 0) {
            errors.push(`Role ${role.id} missing capabilities`);
        }
        if (!role.executionMode)
            errors.push(`Role ${role.id} missing executionMode`);
        if (role.fileMutationAllowed && role.executionMode !== "approval_required" && role.executionMode !== "live") {
            errors.push(`Role ${role.id}: fileMutationAllowed requires approval_required or live executionMode`);
        }
    }
    return { valid: errors.length === 0, errors };
}
//# sourceMappingURL=roles.js.map